import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Button,
  Paper,
  AppBar,
  Toolbar,
  IconButton,
  Drawer,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import {
  Avalanche, One1, Visva, Aurora, Iceberg, Netzero,
  ConstructionIcon,
  EnergyIcon,
  FoodIcon,
  MiningIcon,
  OilIcon,
  PharmaIcon,
  Logo,
  EnvIcon,
  QualityIcon,
  RemoteIcon,
  TransportIcon,
  VideoIcon,
  ContractorIcon,
  EnterPriceIcon,
  SolutionIconBG

} from "../../constant";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

import DescriptionIcon from "@mui/icons-material/Description";
import DownloadIcon from "@mui/icons-material/Download";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import HomeIcon from "@mui/icons-material/Home";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import MenuIcon from "@mui/icons-material/Menu";
import { useNavigate } from "react-router-dom";
import axios from "axios";


const Documentation = () => {
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const [drawerOpen, setDrawerOpen] = useState(false);
  const DOWNLOAD_TYPES = [
    "download-product",
    "download-solution",
    "download-industry",
    "download-others",
  ];

  const [activeTab, setActiveTab] = useState("download-product");

  const [navigationItems, setNavigationItems] = useState({
    "download-product": [],
    "download-solution": [],
    "download-industry": [],
    "download-others": [],
  });

  const [selectedPdf, setSelectedPdf] = useState(null);


  useEffect(() => {
    getList();
  }, [activeTab]);

  useEffect(() => {
    const items = navigationItems[activeTab];

    if (items?.length > 0 && !selectedPdf) {
      setSelectedPdf(items[0]);
    }
  }, [navigationItems, activeTab]);

  const getList = async (page = 1, limit = 100) => {
    try {
      const url = `https://dev.ienergydigital.com/task-api/api/cms/entries/?type=${activeTab}&page=${page}&limit=${limit}`;

      const response = await axios.get(url);

      const entries = response?.data?.data?.entries || [];

      const formattedData = entries
        .filter((item) => item.status === "active")
        .map((item) => {
          const {
            contentJson: {
              icon,
              document,
              tagline = "",
              productName,
              industryName,
              solutionName,
              title,
              name,
            } = {},
          } = item;

          return {
            id: item.id,
            title:
              productName ||
              industryName ||
              solutionName ||
              title ||
              name ||
              "",
            statement: tagline,
            image: icon,
            pdf: document,
          };
        });

      setNavigationItems((prev) => ({
        ...prev,
        [activeTab]: formattedData,
      }));

      if (formattedData.length > 0) {
        setSelectedPdf(formattedData[0]);
      } else {
        setSelectedPdf(null);
      }
    } catch (error) {
      console.error("Error fetching downloads:", error);
    }
  };

  const handleDownload = () => {
    const link = document.createElement("a");

    link.href = selectedPdf.pdf;
    link.download = `${selectedPdf.title}.pdf`;

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const drawerMenuContent = (
    <>
      {DOWNLOAD_TYPES.map((category) => (
        <Box key={category} sx={{ mb: 1 }}>
          <Button
            fullWidth
            onClick={() => setActiveTab(category)}
            sx={{
              justifyContent: "space-between",
              color: "#fff",
              borderRadius: 1,
              mb: 0.5,

              background:
                activeTab === category
                  ? "linear-gradient(90deg, #07329F 0%, #0755FF 100%)"
                  : "rgba(255,255,255,0.05)",
            }}
          >
            {category.replace("download-", "").replace("-", " ")}

            {navigationItems[category]?.length > 0 && (
              <KeyboardArrowDownIcon />
            )}
          </Button>

          {activeTab === category &&
            navigationItems[category]?.length > 0 && (
              <List disablePadding sx={{ pl: 2 }}>
                {navigationItems[category].map((item) => (
                  <ListItemButton
                    key={item.id}
                    onClick={() => {
                      setSelectedPdf(item);
                      setDrawerOpen(false);
                    }}
                    selected={selectedPdf?.id === item.id}
                  >
                    <ListItemText
                      primary={item.title}
                      secondary={item.statement}
                    />
                  </ListItemButton>
                ))}
              </List>
            )}
        </Box>
      ))}
    </>
  );

  const menuContent = (
    <>
      <Typography
        sx={{
          color: "#fff",
          fontSize: 22,
          fontWeight: 600,
          mb: 2,
        }}
      >
        {
          activeTab
            ?.replace("download-", "")
            .replace("-", " ")
            .replace(/\b\w/g, (char) => char.toUpperCase())
        }
      </Typography>

      <List
        sx={{
          maxHeight: "calc(100vh - 220px)",
          overflowY: "auto",

          /* Hide scrollbar - Chrome, Safari */
          "&::-webkit-scrollbar": {
            width: 0,
            display: "none",
          },

          /* Hide scrollbar - Firefox */
          scrollbarWidth: "none",

          /* Hide scrollbar - IE/Edge */
          msOverflowStyle: "none",
        }}
      >
        {navigationItems?.[activeTab]?.map((item) => (
          <ListItemButton
            key={item.id || item.title}
            onClick={() => {
              setSelectedPdf(item);
              setDrawerOpen(false);
            }}
            selected={selectedPdf?.title === item.title}
            sx={{
              borderRadius: "16px",
              mb: 1,
              py: 1,
              alignItems: "flex-start",

              "&.Mui-selected": {
                background:
                  "linear-gradient(90deg, #07329F 0%, #0755FF 100%)",

                "&:hover": {
                  background:
                    "linear-gradient(90deg, #07329F 0%, #0755FF 100%)",
                },
              },

              "&:hover": {
                background: "rgba(255,255,255,0.08)",
              },
            }}
          >
            <Box
              sx={{
                width: 48,
                height: 48,
                borderRadius: "10px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                mr: 2,
                background:
                  "radial-gradient(90.16% 143.01% at 15.32% 21.04%, rgba(165,239,255,0.2) 0%, rgba(110,191,244,0.05) 77%, rgba(70,144,213,0) 100%)",
                flexShrink: 0,
              }}
            >
              <img
                src={item.image}
                alt={item.title}
                style={{
                  width: 32,
                  height: 32,
                  objectFit: "contain",
                }}
              />
            </Box>

            <ListItemText
              primary={item.title}
              secondary={item.statement}
              primaryTypographyProps={{
                color: "#fff",
                fontWeight: 600,
                fontSize: 16,
              }}
              secondaryTypographyProps={{
                color: "rgba(255,255,255,0.7)",
                fontSize: 12,
                sx: { mt: 0.5 },
              }}
            />
          </ListItemButton>
        ))}
      </List>
    </>
  );

  return (
    <Box
      sx={{
        minHeight: "100vh",
        background:
          "linear-gradient(124.71deg, rgba(14,22,88,0.95) -34.29%, #0E1658 122.18%)",
      }}
    >
      {/* Navbar */}
      <AppBar
        position="sticky"
        sx={{
          background:
            "radial-gradient(90.16% 143.01% at 15.32% 21.04%, rgba(165,239,255,0.12) 0%, rgba(110,191,244,0.04) 77%, rgba(70,144,213,0) 100%), linear-gradient(124.71deg, rgba(14,22,88,0) -34.29%, #0E1658 122.18%)",
          backdropFilter: "blur(20px)",
          boxShadow: "0px 5px 15px rgba(0,0,0,0.3)",
          borderBottom: "1px solid rgba(255,255,255,0.1)",
        }}
      >
        <Toolbar
          sx={{
            display: "flex",
            justifyContent: "space-between",
            flexWrap: "wrap",
            gap: 2,
            py: 1,
          }}
        >

          {isMobile && (
            <IconButton
              onClick={() => setDrawerOpen(true)}
              sx={{
                color: "#61D1FA",
                border: "1px solid rgba(97,209,250,0.3)",
              }}
            >
              <MenuIcon />
            </IconButton>
          )}

          {!isMobile && (
            <Box
              sx={{
                display: "flex",
                gap: 1,
                flexWrap: "wrap",
                justifyContent: "flex-start",
                flex: 1,
                px: 2,
              }}
            >
              {DOWNLOAD_TYPES.map((tab) => (
                <Button
                  key={tab}
                  onClick={() => setActiveTab(tab)}
                  sx={{
                    color: "#fff",
                    textTransform: "none",
                    borderRadius: "10px",
                    px: 3,

                    background:
                      activeTab === tab
                        ? "linear-gradient(90deg, #07329F 0%, #0755FF 100%)"
                        : "transparent",

                    "&:hover": {
                      background:
                        activeTab === tab
                          ? "linear-gradient(90deg, #07329F 0%, #0755FF 100%)"
                          : "rgba(255,255,255,0.08)",
                    },
                  }}
                >
                  {
                    tab
                      ?.replace("download-", "")
                      .replace("-", " ")
                      .replace(/\b\w/g, (char) => char.toUpperCase())
                  }
                </Button>
              ))}
            </Box>
          )
          }

          <Button
            startIcon={<HomeIcon />}
            onClick={() => navigate("/")}
            sx={{
              color: "#fff",
              border: "1px solid rgba(97,209,250,0.4)",
              borderRadius: "10px",
              px: 3,
              textTransform: "none",

              "&:hover": {
                background: "rgba(97,209,250,0.1)",
                borderColor: "#61D1FA",
              },
            }}
          >
          </Button>
        </Toolbar>
      </AppBar>

      {/* Mobile Drawer */}
      <Drawer
        anchor="left"
        open={drawerOpen}
        onClose={() => setDrawerOpen(false)}
        PaperProps={{
          sx: {
            width: 300,
            p: 2,
            background:
              "linear-gradient(124.71deg, rgba(14,22,88,0.98) -34.29%, #0E1658 122.18%)",

            overflowY: "auto",

            scrollbarWidth: "none",
            msOverflowStyle: "none",

            "&::-webkit-scrollbar": {
              display: "none",
            },
          },
        }}
      >
        {drawerMenuContent}
      </Drawer>

      {/* Main Content */}
      <Box
        sx={{
          display: "flex",
          flexDirection: {
            xs: "column",
            md: "row",
          },
          gap: {
            xs: 2,
            md: 3,
          },
          p: {
            xs: 1.5,
            sm: 2,
            md: 3,
          },
        }}
      >
        {/* Left Sidebar */}
        {!isMobile && (
          <Paper
            sx={{
              width: 280,
              flexShrink: 0,
              borderRadius: "20px",
              background:
                "radial-gradient(90.16% 143.01% at 15.32% 21.04%, rgba(165,239,255,0.12) 0%, rgba(110,191,244,0.04) 77%, rgba(70,144,213,0) 100%), linear-gradient(124.71deg, rgba(14,22,88,0) -34.29%, #0E1658 122.18%)",
              backdropFilter: "blur(20px)",
              p: 2,

              /* Scrollable */
              maxHeight: "calc(100vh - 120px)",
              overflowY: "auto",

              /* Hide scrollbar - Firefox */
              scrollbarWidth: "none",

              /* Hide scrollbar - IE/Edge */
              msOverflowStyle: "none",

              /* Hide scrollbar - Chrome/Safari */
              "&::-webkit-scrollbar": {
                display: "none",
              },
            }}
          >
            {menuContent}
          </Paper>
        )}

        {/* PDF Viewer */}
        <Paper
          sx={{
            flex: 1,
            borderRadius: "20px",
            overflow: "hidden",
            background:
              "radial-gradient(90.16% 143.01% at 15.32% 21.04%, rgba(165,239,255,0.12) 0%, rgba(110,191,244,0.04) 77%, rgba(70,144,213,0) 100%), linear-gradient(124.71deg, rgba(14,22,88,0) -34.29%, #0E1658 122.18%)",
            backdropFilter: "blur(20px)",
            display: "flex",
            flexDirection: "column",
          }}
        >
          {/* Header */}
          <Box
            sx={{
              p: 2,
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              flexWrap: "wrap",
              gap: 2,
              borderBottom: "1px solid rgba(255,255,255,0.1)",
            }}
          >
            <Typography
              sx={{
                color: "#fff",
                fontSize: 20,
                fontWeight: 600,
              }}
            >
              {selectedPdf?.title}
            </Typography>

            <Button
              variant="contained"
              startIcon={<DownloadIcon />}
              onClick={handleDownload}
              sx={{
                background:
                  "linear-gradient(90deg, #07329F 0%, #0755FF 100%)",
                borderRadius: "10px",
                textTransform: "none",

                "&:hover": {
                  background:
                    "linear-gradient(90deg, #0755FF 0%, #07329F 100%)",
                },
              }}
            >
              Download
            </Button>
          </Box>


          <Box
            sx={{
              width: "100%a",
              height: "100vh",
              margin: 0,
              padding: 0,
              overflow: "hidden",
              background: "#fff",
            }}
          >
            {selectedPdf?.pdf ? (
              <iframe
                src={`${selectedPdf.pdf}#toolbar=0&navpanes=0&scrollbar=0&view=FitH`}
                title={selectedPdf.title}
                width="100%"
                height="100%"
                style={{
                  border: "none",
                  display: "block",
                }}
              />
            ) : (
              <Box
                sx={{
                  height: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  color: "#fff",
                }}
              >
                No PDF available
              </Box>
            )}
          </Box>

          {/* PDF Viewer */}

        </Paper>
      </Box>
    </Box>
  );
};

export default Documentation;